import React, { Component } from "react";

import {CyclingStep} from "./CyclingStep"
import {ConstantStep} from "./ConstantStep"
import {FinalStep} from "./FinalStep"

import "./style.scss";

class RenderLine extends Component {

  constructor(props) {
    super(props);

    this.state = {
      maxHeight: 0,
      lineOffsets: []
    };

    this.chartarea = React.createRef();
  }

  setMaxHeight = () => {
    let height = (this.chartarea.current.getBoundingClientRect().height - 52)

    this.setState({
      maxHeight: height
    }, ()=>{

      this.setState({
        lineOffsets: this.props.sequence.flatMap(step => {
          if(step.type === "constant"){
            return (this.state.maxHeight - this.convertTempToOffset(step.temp))
          }
          if(step.type === "cycling"){
            return step.subSteps.map(subStep => {
              return (this.state.maxHeight - this.convertTempToOffset(subStep.temp))
            })
          }
          if(step.type === "final"){
            return (this.state.maxHeight - this.convertTempToOffset(step.temp))
          }
        })
      })
    })
  }

  convertTempToOffset = (temp) => {

    let percentage = temp / 95;
    return (this.state.maxHeight * (percentage));
  }

  componentDidMount() {
    // Resize the scene and attach the resize method to the window resize event
    this.setMaxHeight()
    window.addEventListener("resize", this.setMaxHeight);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.setMaxHeight);
  }
  componentDidUpdate(prevProps, prevState) {
    if(this.props.sequence !== prevProps.sequence){
      this.setMaxHeight()
    }
  }

  render() {
    return (
      <div className="line-plot" style={{
        display: "flex",
        flexDirection: "column",
        position: "absolute",
        height: "calc(100% - 131px)",
        marginTop: "76px",
        pointerEvents: "none"
      }}>
        <div
          className="step-line"
          ref={this.chartarea}
          style={{
            display: "flex",
            flexDirection: "row",
            height: "100%"
          }}
          >
          {
            this.state.lineOffsets.map((offset, index)=>(
              <div style={{
                width: "150.5px",
                position: "relative"
              }}>
                <div
                  style={{
                    transform: "translate3d(0px, "+(offset + 25)+"px, 0px) rotateZ(0deg)",
                    width: "calc(100% - 16px)",
                    height: "1px",
                    background: "#003E6B",
                    marginTop: "27px",
                    marginLeft: "8px"
                  }}
                ></div>
                {(index !== (this.state.lineOffsets.length - 1))?(
                  <div
                    style={{
                      position: "absolute",
                      transform: "translate3d(0px, "+(offset + 25)+"px, 0px) rotate("+(-Math.atan((offset - this.state.lineOffsets[index + 1]) / 16) * (180 / Math.PI))+"deg)",
                      width: Math.sqrt(Math.pow((offset - this.state.lineOffsets[index + 1]), 2) + Math.pow(16, 2))+"px",
                      height: "1px",
                      transformOrigin: "top left",
                      background: "#003E6B",
                      marginLeft: "calc(100% - 8px)",
                      marginTop: "-1px"
                    }}
                  ></div>
                ):null}
              </div>
            ))
          }
        </div>
      </div>
    )
  }
}

export class StepEdit extends Component {
  render() {
    return (
      <div className="thermocycler-table-edit" style={{display: "flex", flexDirection: "row"}}>
        {
          this.props.sequence.map(step => {
            if(step.type === "constant"){
              return <ConstantStep
                        id={this.props.id}
                        props={step}
                        sequence={this.props.sequence}
                        updateSequence={this.props.updateSequence}
                        updateSequenceTemp={this.props.updateSequenceTemp}
                        updateSequenceTime={this.props.updateSequenceTime}
                        updateSequenceRepeat={this.props.updateSequenceRepeat}
                        saved={this.props.saved}
                        setSaved={this.props.setSaved}
                      />
            }
            if(step.type === "cycling"){
              return <CyclingStep
                        id={this.props.id}
                        props={step}
                        sequence={this.props.sequence}
                        updateSequence={this.props.updateSequence}
                        updateSequenceTemp={this.props.updateSequenceTemp}
                        updateSequenceTime={this.props.updateSequenceTime}
                        updateSequenceRepeat={this.props.updateSequenceRepeat}
                        saved={this.props.saved}
                        setSaved={this.props.setSaved}
                      />
            }
            if(step.type === "final"){
              return <FinalStep
                        id={this.props.id}
                        props={step}
                        sequence={this.props.sequence}
                        updateSequence={this.props.updateSequence}
                        updateSequenceTemp={this.props.updateSequenceTemp}
                        updateSequenceTime={this.props.updateSequenceTime}
                        updateSequenceRepeat={this.props.updateSequenceRepeat}
                        saved={this.props.saved}
                        setSaved={this.props.setSaved}
                      />
            }
            return null
          })
        }
        <RenderLine sequence={this.props.sequence} />
      </div>
    )
  }
}
